import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppRoleDto, MaskingDto, MaskingTypeEnum, PermissionDto, RolePermissionEnum, RolePermissionGroupEnum } from '../../service/dto';
import { HttpMaskingService } from '../../service/http-masking.service';
import { HttpAppRoleService } from '../../service/http-app-role.service';
import { NzMessageService } from 'ng-zorro-antd/message';

class RoleWrapper {
	roleId!: number;
	selected!: boolean;
}

class PermissionWrapper {
	permission!: RolePermissionEnum;
	label!: string;
	description?: string;
	roles!: RoleWrapper[];
}

@Component({
	selector: 'app-permissions',
	standalone: false,
	templateUrl: './permissions.component.html',
	styleUrl: './permissions.component.scss'
})
export class PermissionsComponent implements OnInit, OnDestroy {
	appRoles: AppRoleDto[] = [];
	agentPermissions: PermissionWrapper[] = [];
	partnerPermissions: PermissionWrapper[] = [];
	importPermissions: PermissionWrapper[] = [];
	subscriberPermissions: PermissionWrapper[] = [];
	maskingPermissions: PermissionWrapper[] = [];
	systemPermissions: PermissionWrapper[] = [];

	constructor(private service: HttpAppRoleService, private messageService: NzMessageService) { }

	ngOnInit(): void {
		this.service.getAll().subscribe(result => this.populate(result));
	}
	ngOnDestroy(): void {

	}
	private populate(input: AppRoleDto[]) {
		this.appRoles = input;
		this.agentPermissions = this.parse(input, 'Agent');
		this.partnerPermissions = this.parse(input, 'Partner');
		this.importPermissions = this.parse(input, 'Import');
		this.subscriberPermissions = this.parse(input, 'Subscriber');
		this.maskingPermissions = this.parse(input, 'Masking');
		this.systemPermissions = this.parse(input, 'System');
	}
	private parse(input: AppRoleDto[], filter: RolePermissionGroupEnum): PermissionWrapper[] {
		const uniquePermissions: PermissionDto[] = [];
		input.forEach(role => {
			role.permissions.filter(p => !filter || p.group === filter).forEach(p => {
				if (uniquePermissions.filter(i => i.permission == p.permission).length == 0) {
					uniquePermissions.push(p);
				}
			});
		});
		return uniquePermissions.map(item => {
			return {
				label: item.label,
				permission: item.permission,
				description: item.description,
				roles: input.map(i => {
					return {
						roleId: i.id,
						selected: i.permissions.filter(j => j.selected == true).filter(j => j.permission == item.permission).length != 0
					};
				})
			};
		});
	}
	doSubmit() {
		const tmp = JSON.stringify(this.appRoles);
		const payload: AppRoleDto[] = JSON.parse(tmp);
		payload.forEach(item => {
			item.permissions = [];
		});

		const allPermissions = [
			...this.agentPermissions,
			...this.partnerPermissions,
			...this.importPermissions,
			...this.subscriberPermissions,
			...this.maskingPermissions,
			...this.systemPermissions
		].forEach(permissionWrapper => {
			permissionWrapper.roles.filter(item => item.selected == true).forEach(roleWrapper => {
				payload.filter(item => item.id == roleWrapper.roleId).forEach(appRole => {
					appRole.permissions.push({
						group: 'System',
						label: permissionWrapper.label,
						permission: permissionWrapper.permission,
						selected: true,
						hashCode: 0
					});
				})
			});
		});


		this.service.savePermissions(payload).subscribe(result => {
			this.populate(result);
			this.messageService.info("Permissions Saved");
		});
	}
	trackByPermission(index: number, item: PermissionWrapper): any {
		return item.permission;
	}
	trackByRole(index: number, item: RoleWrapper): any {
		return item.roleId;
	}
}
